import React from 'react';

/**
 * Skeleton de form baseado no `<FormGrid>` (REDLINE-loading.md §5).
 *
 * <p>Preserva a grade de `cols` colunas do FormGrid real via style inline —
 * NÃO colapsa em coluna única em breakpoint estreito (o real colapsa em
 * `max-width: 640px`, ver Shell.css:72; mas o skeleton mantém as N colunas
 * pra não prometer forma diferente da que vai entregar). Se o skeleton
 * colapsasse, o layout saltaria quando os dados chegassem em mobile.
 *
 * <p><b>Anatomia:</b> por célula = label 60-80px × 9px (margin-bottom 7) +
 * input 100% × 38px (radius 9). Larguras da label variam pra não parecer
 * grid uniforme mecânico.
 *
 * <p>Sem delay interno — caller decide.
 *
 * @param cols  1|2|3 — colunas do grid (default 3).
 * @param rows  Número de linhas do grid (default 3). Total de campos = cols × rows.
 */
export default function FormGridSkeleton({ cols = 3, rows = 3 }) {
	const total = cols * rows;
	// Larguras variadas pras labels — evita fileira uniforme.
	const labelWidths = [60, 72, 80, 66, 74, 62, 78, 68, 70];
	return (
		<div
			aria-busy="true"
			aria-live="polite"
			style={{
				display: 'grid',
				gridTemplateColumns: `repeat(${cols}, 1fr)`,
				gap: 16,
				marginBottom: 22,
			}}
		>
			{Array.from({ length: total }).map((_, i) => (
				<div key={i} aria-hidden="true">
					<span
						className="sk"
						style={{ width: labelWidths[i % labelWidths.length], height: 9, marginBottom: 7, display: 'block' }}
					/>
					<span
						className="sk"
						style={{ width: '100%', height: 38, borderRadius: 9, display: 'block' }}
					/>
				</div>
			))}
		</div>
	);
}
